// src/components/OrderCard/OrderCard.jsx

// react-routers components
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import Card from '@mui/material/Card';
import SoftBox from 'components/SoftBox';
import SoftTypography from 'components/SoftTypography';

import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import PersonIcon from '@mui/icons-material/Person';
import PublicIcon from '@mui/icons-material/Public';
import PlaceIcon from '@mui/icons-material/Place';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';

function OrderCard({ numero, info, action, showEmptyLabels = false, emptyPlaceholder = '—' }) {
  // Campos en orden fijo
  const FIELD_ORDER = [
    { key: 'cliente',              label: 'Cliente',              Icon: LocalShippingIcon },
    { key: 'Fecha de Embarque',    label: 'Fecha de Embarque',    Icon: CalendarTodayIcon },
    { key: 'Fecha de Arribo',      label: 'Fecha de Arribo',      Icon: CalendarTodayIcon },
    { key: 'Fecha Real de Arribo', label: 'Fecha Real de Arribo', Icon: CalendarTodayIcon },
    { key: 'responsable',          label: 'Responsable',          Icon: PersonIcon },
    { key: 'proveedor',            label: 'Proveedor',            Icon: PublicIcon },
    { key: 'incoterms',            label: 'Incoterms',            Icon: PublicIcon },
    { key: 'transporte',           label: 'Transporte',           Icon: LocalShippingIcon },
    { key: 'origen',               label: 'Origen',               Icon: PlaceIcon },
    { key: 'status',               label: 'Estado',               Icon: CalendarTodayIcon },
  ];

  // 👇 Campos que SIEMPRE se muestran aunque estén vacíos
  const ALWAYS_SHOW_KEYS = new Set(['Fecha de Embarque']);

  return (
    <Card sx={{ width: '45vh', height: '100%' }}>
      <SoftBox p={2}>
        <SoftTypography variant="body2" fontWeight="medium">
          <strong>{numero}</strong>
        </SoftTypography>

        {info && FIELD_ORDER.map(({ key, label, Icon }) => {
          const raw = info[key];
          const isEmpty = raw === undefined || raw === null || String(raw).trim() === '';

          // Oculta si está vacío, salvo que:
          // - showEmptyLabels sea true, o
          // - el campo esté en ALWAYS_SHOW_KEYS
          if (!showEmptyLabels && !ALWAYS_SHOW_KEYS.has(key) && isEmpty) return null;

          const value = isEmpty ? emptyPlaceholder : raw;

          return (
            <SoftTypography key={key} variant="body2" sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
              {Icon && <Icon fontSize="small" sx={{ mr: 0.5 }} />}
              <strong style={{ marginRight: 6 }}>{label}:</strong> {value}
            </SoftTypography>
          );
        })}
      </SoftBox>
    </Card>
  );
}

OrderCard.propTypes = {
  numero: PropTypes.string.isRequired,
  info: PropTypes.objectOf(PropTypes.string).isRequired,
  action: PropTypes.shape({
    route: PropTypes.string,
    tooltip: PropTypes.string,
  }),
  showEmptyLabels: PropTypes.bool,
  emptyPlaceholder: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

OrderCard.defaultProps = {
  action: {},
  showEmptyLabels: false,
  emptyPlaceholder: '—',
};

export default OrderCard;
